"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get MfaWebAuthnChallengeRequestSchema () {
        return MfaWebAuthnChallengeRequestSchema;
    },
    get MfaWebAuthnChallengeResponseSchema () {
        return MfaWebAuthnChallengeResponseSchema;
    },
    get MfaWebAuthnChallengeStartRequestSchema () {
        return MfaWebAuthnChallengeStartRequestSchema;
    },
    get MfaWebAuthnChallengeStartResponseSchema () {
        return MfaWebAuthnChallengeStartResponseSchema;
    },
    get MfaWebAuthnChallengeVerifyRequestSchema () {
        return MfaWebAuthnChallengeVerifyRequestSchema;
    },
    get MfaWebAuthnChallengeVerifyResponseSchema () {
        return MfaWebAuthnChallengeVerifyResponseSchema;
    },
    get StartRequestSchema () {
        return StartRequestSchema;
    },
    get StartResponseSchema () {
        return StartResponseSchema;
    },
    get VerifyRequestSchema () {
        return VerifyRequestSchema;
    },
    get VerifyResponseSchema () {
        return VerifyResponseSchema;
    }
});
const _zod = require("zod");
const _tokenpair = require("./token-pair");
const StartRequestSchema = _zod.z.object({
    mfaToken: _zod.z.string().min(20)
});
const StartResponseSchema = _zod.z.object({
    options: _zod.z.record(_zod.z.string(), _zod.z.unknown()),
    challengeId: _zod.z.string().uuid()
});
const VerifyRequestSchema = _zod.z.object({
    mfaToken: _zod.z.string().min(20),
    challengeId: _zod.z.string().uuid(),
    response: _zod.z.object({
        id: _zod.z.string().min(1),
        rawId: _zod.z.string().min(1),
        type: _zod.z.literal('public-key'),
        response: _zod.z.object({
            clientDataJSON: _zod.z.string().min(1),
            authenticatorData: _zod.z.string().min(1),
            signature: _zod.z.string().min(1),
            userHandle: _zod.z.string().optional()
        }),
        clientExtensionResults: _zod.z.record(_zod.z.string(), _zod.z.unknown()).default({}),
        authenticatorAttachment: _zod.z.enum([
            'platform',
            'cross-platform'
        ]).optional()
    })
});
const VerifyResponseSchema = _tokenpair.TokenPairSchema;
const MfaWebAuthnChallengeStartRequestSchema = StartRequestSchema;
const MfaWebAuthnChallengeStartResponseSchema = StartResponseSchema;
const MfaWebAuthnChallengeVerifyRequestSchema = VerifyRequestSchema;
const MfaWebAuthnChallengeVerifyResponseSchema = VerifyResponseSchema;
const MfaWebAuthnChallengeRequestSchema = _zod.z.union([
    StartRequestSchema.extend({
        response: _zod.z.undefined()
    }),
    VerifyRequestSchema
]);
const MfaWebAuthnChallengeResponseSchema = _zod.z.union([
    StartResponseSchema,
    VerifyResponseSchema
]);
